import Formula from '@hapi/formula'
import { getFormatDate } from './common'
import {
  CONCATENATE,
  DATEDIF,
  IF,
  IFS,
  ROUND,
  SUM,
  ABS,
  AVERAGE,
  COUNT,
  COUNTIF,
  MAX, MIN, INT,
  PRODUCT,
  SUMPRODUCT,
  UPPER, LOWER,
  EXACT,
  LEFT, RIGHT, LEN,
  REPLACE,
  MID,
  YEAR,
  MONTH, DAY, HOUR, MINUTE, SECOND, NETWORKDAYS, WORKDAY, NOW, TODAY, WEEKNUM, WEEKDAY,
  AND,
  OR,
  XOR
} from '@formulajs/formulajs'

const functions = {
  CONCATENATE,
  DATEDIF,
  IF,
  IFS,
  ROUND,
  SUM,
  ABS,
  AVERAGE,
  COUNT,
  COUNTIF,
  MAX, MIN, INT,
  PRODUCT,
  SUMPRODUCT,
  UPPER, LOWER,
  EXACT,
  LEFT, RIGHT, LEN,
  REPLACE,
  MID,
  YEAR,
  MONTH, DAY, HOUR, MINUTE, SECOND, NETWORKDAYS, WORKDAY, WEEKNUM, WEEKDAY,
  AND,
  OR,
  XOR,
  FIXED(v, precision) {
    if (typeof v === 'number') {
      return v.toFixed(precision || 0)
    }
  },
  TODAY() {
    return getFormatDate(TODAY(), 'date')
  },
  NOW() {
    return getFormatDate(NOW())
  },
  UNION: (...arg) => [...new Set(arg)],
  DATEDELTA: (value: string, day: number) => {
    let time = new Date(value)
    time.setDate(time.getDate() + day)
    return getFormatDate(time)
  },
  TIMEDIF: (start, end, unit) => {
    if (!start || !end || !unit) {
      return ''
    }
    let startT = new Date(start).getTime()
    let endT = new Date(end).getTime()
    let delta = endT - startT
    switch (unit) {
      case 's':
        delta = delta / 1000
        break
      case 'm':
        delta = delta / 1000 / 60
        break
      case 'h':
        delta = delta / 1000 / 60 / 60
        break
      case 'd':
        delta = delta / 1000 / 60 / 60 / 24
        break
      case 'M':
        delta = delta / 1000 / 60 / 60 / 24 / 30
        break
      case 'y':
        delta = delta / 1000 / 60 / 60 / 24 / 365
        break
    }
    return delta
  }
}
const reference = (name) => {
  return (context) => context[name.slice(7, -1)];
};
// 缓存已解析的公式
let formulaCache = {

}
// fixed count, countIf实现
// 用法
// const formula = new Formula.Parser('1 + a.b.c.2.4.x + b + x(y + 4)', { functions, reference });
// console.log(formula.evaluate({ 'b: 3, 'y': 5 }))       // 1 + 2 + 3 + 5 + 10 + 100
export function getFormula(field) {
  if (formulaCache[field.businessId]) {
    return formulaCache[field.businessId]
  } else {
    formulaCache[field.businessId] = new Formula.Parser(field.defaultValue, { functions, reference });
    return formulaCache[field.businessId]
  }
}
export function clearFormulaCache() {
  formulaCache = {}
}
